import { Controller } from "@hotwired/stimulus"
import { get } from '@rails/request.js'

// Connects to data-controller="buscar-reportes"
export default class extends Controller {
  static targets = ["desde", "hasta", "obraSocial", "hoja"]
  static values = {
    url: String,
    registro: Number,
    processingReport: Boolean
  }

  connect() {
    this.processingReportValue = Boolean(this.data.get("processingReport"));
  }

  imprimir(event) {
    event.preventDefault()

    const hoja = this.hojaTarget?.value
    const desde = this.desdeTarget?.value
    const hasta = this.hastaTarget?.value

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("registro", this.registroValue)

    if (hoja && hoja.trim() !== "") {
      url.searchParams.set("hoja", hoja)
    }
    if (desde && desde.trim() !== "") {
      url.searchParams.set("start_date", desde)
    }
    if (hasta && hasta.trim() !== "") {
      url.searchParams.set("end_date", hasta)
    }

    url.searchParams.set("format", "pdf")
    window.open(url.toString(), "_blank")
  }

  imprimirLote(e) {
    e.preventDefault()
    const obraSocialValue = this.obraSocialTarget.value;

    get(`${this.urlValue}?start_date=${this.desdeTarget.value}&end_date=${this.hastaTarget.value}&obra_social=${obraSocialValue}`, { responseKind: 'turbo-stream' })
  }
}
